export class VesselAnnouncement {
    estimatedArrivalDate = null;
}
